require("!!/Users/bshank/Development/offer-archer/node_modules/script-loader/addScript.js")(require("!!/Users/bshank/Development/offer-archer/node_modules/raw-loader/index.js!/Users/bshank/Development/offer-archer/node_modules/jquery-slimscroll/jquery.slimscroll.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/jquery-slimscroll/jquery.slimscroll.js
// module id = 491
// module chunks = 17